import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { validOnTimeDelayTypes } from "../../../Appconstants";
import { onTimeDelayProduction } from "../../../redux/actions/API/dashboardActions";
import ProductionExtra from "./ProductionExtra";

interface IOnTimeDelayProductionItemsProps {
  onTimeDelayProduction: Function;
  onTimeDelayProductionState: any;
  onTimeDelayProductionLoading: boolean;
  companyId: any;
}

const ON_TIME_DELAY_LABEL_MAP: Record<string, string> = {
  onTime: "On Time",
  delay: "Delay",
};

const OnTimeDelayProductionItems: React.FC<
  IOnTimeDelayProductionItemsProps
> = ({
  companyId,
  onTimeDelayProduction,
  onTimeDelayProductionState,
  onTimeDelayProductionLoading,
}) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const typeIndexParam = Number(searchParams.get("typeIndex"));
  const hasValidTypeIndex =
    Number.isInteger(typeIndexParam) &&
    typeIndexParam >= 0 &&
    typeIndexParam < validOnTimeDelayTypes.length;
  const selectedTypeIndex = hasValidTypeIndex ? typeIndexParam : 0;

  const orderedTypeIndexes = hasValidTypeIndex
    ? [
        selectedTypeIndex,
        ...validOnTimeDelayTypes
          .map((_: string, index: number) => index)
          .filter((index: number) => index !== selectedTypeIndex),
      ]
    : validOnTimeDelayTypes.map((_: string, index: number) => index);

  const dropdownOptions = orderedTypeIndexes.map((index: number) => {
    const type = validOnTimeDelayTypes[index];
    return {
      label: ON_TIME_DELAY_LABEL_MAP[type] || type,
      value: index,
    };
  });

  useEffect(() => {
    const resolvedType =
      validOnTimeDelayTypes[selectedTypeIndex] || validOnTimeDelayTypes[0];

    onTimeDelayProduction({
      companyId: Number(companyId),
      type: resolvedType,
    });
  }, [companyId, selectedTypeIndex, onTimeDelayProduction]);

  const handleDropdownChange = (value: string | number) => {
    navigate(`/onTimeDelayProductionItems?typeIndex=${Number(value)}`);
  };

  return (
    <ProductionExtra
      breadcrumbTitle="On Time/Delay Production"
      dropdownOptions={dropdownOptions}
      loading={onTimeDelayProductionLoading}
      selectedValue={selectedTypeIndex}
      handleDropdownChange={handleDropdownChange}
      tableData={onTimeDelayProductionState}
    />
  );
};

const mapStateToProps = (state: any) => ({
  companyId: state.api.login?.data?.companyId,
  onTimeDelayProductionState:
    state.api.getOnTimeDelayProduction?.onTimeDelayProduction,
  onTimeDelayProductionLoading: state.api.getOnTimeDelayProduction?.loading,
});

const mapDispatchToProps = (dispatch: any) => ({
  onTimeDelayProduction: (payload: any) =>
    dispatch(onTimeDelayProduction(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OnTimeDelayProductionItems);
